import styles from "./SelectedService.module.css";
import { useContext, useEffect, useState } from "react";
import DataContext from "../../store/data-context";
import Service from "../../UI/_Srvice/Service";
import List from "./List";
import DescriptionList from "./DescriptionList";
import InSiteLogo from "../../UI/InSiteLogo";

export default function SelectedselectedService({}) {
    const {
        selectedService,
        additionalOptions,
        setAdditionalOptions,
        setInHelp,
    } = useContext(DataContext);

    useEffect(() => {
        setInHelp({
            title: "Odabir dodatnih usluga",
            description:
                "Odabrali ste internet uslugu. Ovdje možete odabrati dodatne usluge 'MojaTV' i 'Telefon' te odrediti koliko usluga želite. (UREĐAJI NISU UKLJUČENI U OPCIJU) Ove opcije nisu obavezne. Kada završite, pritisnite gumb 'Pošalji upit' za nastavak.",
            active: false,
            quickTip: true,
            questions: [],
        });
    }, []);

    const onServiceAdd = (e) => {
        const value = e.currentTarget.getAttribute("value");
        let temp = [...additionalOptions];
        const tempIndex = temp.findIndex((el) => el.name === value);

        if (temp[tempIndex].value === 0) {
            temp = temp.filter((el) => el.name !== value);
            temp.push({ name: value, value: 1 });
        } else {
            temp[tempIndex].value += 1;
        }

        setAdditionalOptions(temp);
    };

    const onServiceRemove = (item, whole = false) => {
        const temp = [...additionalOptions];
        const tempIndex = temp.findIndex((el) => el.name === item.name);

        if (whole || item.value < 2) {
            item.value = 0;
        } else {
            item.value = item.value - 1;
        }

        setAdditionalOptions(temp);
    };

    return (
        <>
            {selectedService && (
                <div className={styles.container}>
                    <InSiteLogo />
                    <div className={styles[`info`]}>
                        <Service service={selectedService} action={false} />
                        {/*<div>{selectedService.name}</div>
                        <div>{selectedService.speed}</div>
                        <div>{selectedService.service_type}</div>
                        <div>{selectedService.service_group}</div>*/}
                    </div>

                    <div className={styles[`additional-actions`]}>
                        <div
                            className={styles[`add-additional-service`]}
                            onClick={onServiceAdd}
                            value={"MojaTV"}
                        >
                            <div
                                className={
                                    styles[`add-additional-service-button`]
                                }
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 100 100"
                                    className={styles[`add-mark`]}
                                >
                                    <line
                                        x1="50"
                                        y1="20"
                                        x2="50"
                                        y2="80"
                                        stroke="currentColor"
                                        strokeWidth="10"
                                    />
                                    <line
                                        x1="20"
                                        y1="50"
                                        x2="80"
                                        y2="50"
                                        stroke="currentColor"
                                        strokeWidth="10"
                                    />
                                </svg>
                            </div>
                            Dodaj MojaTV
                        </div>
                        <div
                            className={styles[`add-additional-service`]}
                            onClick={onServiceAdd}
                            value={"Telefon"}
                        >
                            <div
                                className={
                                    styles[`add-additional-service-button`]
                                }
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 100 100"
                                    className={styles[`add-mark`]}
                                >
                                    <line
                                        x1="50"
                                        y1="20"
                                        x2="50"
                                        y2="80"
                                        stroke="currentColor"
                                        strokeWidth="10"
                                    />
                                    <line
                                        x1="20"
                                        y1="50"
                                        x2="80"
                                        y2="50"
                                        stroke="currentColor"
                                        strokeWidth="10"
                                    />
                                </svg>
                            </div>
                            Dodaj Telefon
                        </div>
                    </div>

                    {!additionalOptions.find((el) => el.value > 0) ? (
                        <DescriptionList />
                    ) : (
                        <List
                            services={additionalOptions}
                            onServiceAdd={onServiceAdd}
                            onServiceRemove={onServiceRemove}
                        />
                    )}
                </div>
            )}
        </>
    );
}
